import {
  CYCLE_UNIT_CONTRACT_PERIOD,
  CYCLE_UNIT_DAILY,
CYCLE_UNIT_MONTHLY,
CYCLE_UNIT_ONE_TIME,
CYCLE_UNIT_WEEKLY,
CYCLE_UNIT_YEARLY
} from "../constants/cycleUnit";
import type { LocalizedText } from "../i18n/i18n";

const cycleUnitKeys: Record<number, string> = {
  [CYCLE_UNIT_MONTHLY]: "Cycle unit monthly",
  [CYCLE_UNIT_WEEKLY]: "Cycle unit weekly",
  [CYCLE_UNIT_ONE_TIME]: "Cycle unit once",
  [CYCLE_UNIT_YEARLY]: "Cycle unit yearly",
  [CYCLE_UNIT_DAILY]: "Cycle unit daily",
  [CYCLE_UNIT_CONTRACT_PERIOD]: "Cycle unit contract period"
};

/** English i18n key for a backend CycleUnit value (1…5), or null if unknown. */
export function cycleUnitLabelKey(unit: number | null | undefined): string | null {
  if (unit == null || Number.isNaN(Number(unit))) return null;
  return cycleUnitKeys[Number(unit)] ?? null;
}

export function formatCycleUnitLabel(unit: number | null | undefined, text: (value: LocalizedText) => string): string {
  const key = cycleUnitLabelKey(unit);
  return key ? text(key) : "";
}

/**
 * Einheit als Zeitraum-Substantiv statt als Rhythmus-Adverb: „12 Monate", nicht „12 monatlich".
 * Gebraucht überall dort, wo eine Laufzeit benannt wird — die Rhythmus-Fassung oben passt dort nicht.
 */
const cycleUnitDurationKeys: Record<number, string> = {
  [CYCLE_UNIT_DAILY]: "Days",
  [CYCLE_UNIT_WEEKLY]: "Weeks",
  [CYCLE_UNIT_MONTHLY]: "Months",
  [CYCLE_UNIT_YEARLY]: "Years"
};

const cycleUnitDurationSingularKeys: Record<number, string> = {
  [CYCLE_UNIT_DAILY]: "Day",
  [CYCLE_UNIT_WEEKLY]: "Week",
  [CYCLE_UNIT_MONTHLY]: "Month",
  [CYCLE_UNIT_YEARLY]: "Year"
};

/** Einheit einer Dauer; mit `count === 1` in der Einzahl („1 Monat" statt „1 Monate"). */
export function formatCycleUnitDurationLabel(
  unit: number | null | undefined,
  text: (value: LocalizedText) => string,
  count?: number
): string {
  if (unit == null || Number.isNaN(Number(unit))) return "";
  const key = (count === 1 ? cycleUnitDurationSingularKeys : cycleUnitDurationKeys)[Number(unit)];
  return key ? text(key) : "";
}

/** Select options for payment / duration cycle (same order as Vertragsbaustein-Einstellungen). */
export function cycleUnitSelectOptions(text: (value: LocalizedText) => string) {
  return [
    { value: CYCLE_UNIT_ONE_TIME, label: text("Cycle unit once") },
    { value: CYCLE_UNIT_DAILY, label: text("Cycle unit daily") },
    { value: CYCLE_UNIT_WEEKLY, label: text("Cycle unit weekly") },
    { value: CYCLE_UNIT_MONTHLY, label: text("Cycle unit monthly") },
    { value: CYCLE_UNIT_YEARLY, label: text("Cycle unit yearly") }
  ];
}
